/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import TagManager from 'react-gtm-module';
import $ from 'jquery';

function Caption0304() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])

	return (
		<>
			<div className="popup" id="mb_pop01">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 比利一直在商務差旅，以及日本、歐洲、美加線等歷史、文化、藝術相關旅遊，有著相當深度的耕耘以及豐富的出團經驗。比利大視野 用聲音 帶大家環遊世界。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop02">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。初次來到貴寶地，請多多照顧呦！ 鴨子一窩瘋，瘋什麼？這是一個與你分享異地生活狀況外的聊天室，瘋的是這世界各方各土獨有的人文風情，當我們在初來乍到一地時所撞擊出的各種有趣文化體驗！</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop03">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>豐富您的不只是藝術知識，更是與親友共享藝術的時光。 生活忙碌的您，多久沒有接觸藝術了呢？ 您已是個博物館超級粉絲，但尚未找到能夠方便接觸藝術的管道？ 在i聽聽，和老派博粉一起重新認識博物館吧！ 每週二、三晚上，您將前往世界各地的博物館，例如故宮、大都會博物館或大英博物館等等，生動有趣又富含知識地，聆聽博物館和藝術品背後的故事。 讓【博物館二三事】陪您與藝術同行，隨時隨地享受不一樣的博物館參觀經驗。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop04">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 暖氣藥師告訴你吃藥大小事、分享最新醫藥相關話題，以及藥局軼事。不分男女，由老到少，無論是保健食品還是藥品，都讓暖氣伴隨，成為你的健康守護者。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop05">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>乳房，對於女性而言，無疑是重要而特別的。從青春發育、懷孕、哺乳、直到更年，乳房隨著女性生命中不同的階段，而有不同的面貌。乳房不單只是用作哺育的器官，有時候，她也象徵了女性的美與自信。然而，「乳癌」高居台灣婦癌發生率的第一名，我們都希望乳房能健康無恙，甚至保有她外在的美麗。妳是不是也曾對乳房產生好多疑問？ 在「池永昌醫師的乳房私房話」，乳房專科池永昌醫師要用專業的角度，解答妳一切有關乳房的疑問，更要告訴妳：「別怕！乳癌是可治之症！」 i聽聽出品Podcast節目，每週更新。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop06">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>您是否也有一些日常生活中的健康大小事不知道該如何處理呢？或是對於時下最紅的健康議題一無所知？健康小管家，照顧你全家！由受過專業的醫療人員：「Wendy護理師」及「微唐營養師」陪您一起攜手照顧好你跟你的家人！我們的內容涵蓋健康時事新聞、生活迷思解惑、醫學生活護理、保健營養建議、精準醫療新知、基因檢測介紹等，讓你可以一手掌握各式健康資訊。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop07">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 40歲的單身媽媽，與尼奧相伴。 愛繪本、電影、追劇、閱讀， 想在派對中與妳聊聊女性相關的話題， 尼奧媽的單身派對是個休息站， 在妳心好累的時候， 我會打開雙臂， 給妳滿滿的溫暖。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop08">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>《荒漠甘泉》暢銷於世界各地，它曾經陪伴許多讀者走過生命的低潮。《童書裡的荒漠甘泉》的作者張淑瓊，結合了「童書」與「荒漠甘泉」，透過童書重新詮釋荒漠甘泉裡的信息，讓好故事和好信息相遇，幫助讀者在閱讀中找到前進的力量，面對生活、面對自己、也面對世界。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop09">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>今天你與孩子一起共讀了嗎？ 大家都知道親子共讀的重要性，可是往往在開始共讀之後，才發現講故事這件事，好像沒有想像中的簡單，從如何選書到怎麼講故事，甚至孩子到底有沒有耐心聽，聽懂了沒？這都是我們在親子共讀中普遍遇到的困難和問題，小大繪本館館長譚淑娟在「快樂共讀行不行」分享親子共讀中的大小事，希望透過每一次的分享，陪伴著你與孩子以更輕鬆的腳步邁向共讀之路。 【主播簡介】譚淑娟 小大繪本館館長，長期致力於親子共讀推廣與繪本讀書會運作輔導，經常受邀至海內外各幼教機構及大專院校擔任繪本教學運用與說故事實務培訓講師，並參與偏鄉部落故事閱讀深耕工作。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop10">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 延續 侯昌明 生活大師的形象，親切、幽默的主持方式，在節目中跟大家分享生活大小事，傳授好撇步，讓生活輕輕鬆鬆 侯賽雷！</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop11">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 職場媽咪趙小僑，訪問女生關心的話題，讓你輕鬆獲知女人大小事。追幸福沒公式！</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop12">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目，每週更新。 劉亮佐 主持的「劉亮佐有藝思」。 本科系出身，劉亮佐（斗哥）劇場多年的經驗，匯集多方的藝文相關資訊，點出有別於一般藝文觀點，帶大家更深入探索，對藝文耳目一新！</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop13">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>寶石獵人李承倫，踏尋世界鑽石與寶石秘境，結合歷史、市場動向、礦區資訊、與專業實務經驗，帶領聽眾進入珠寶的殿堂。內容深入淺出，適合一般大眾，讓您從僅是看熱鬧的層次，進階到懂得看門道。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop14">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>i聽聽出品Podcast節目。 作家對談，現代文學為主。 深度訪談作者創作靈感，從為誰而寫到為何而寫。 文學不是成功學，但它卻是所有人的人生風景。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop15">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>真正的閱讀不只是藉由視覺的傳遞，而是通過心靈去感受、去理解。 由心理學家裘凱宇與諮商心理師楊嘉玲共同主持，邀請你透過聆聽，體驗真心的交流，讓《有聲書評》成為你認識世界的另一扇窗。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop16">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>生命裡有各式各樣的煩惱，有人能給出終極答案，但有人陪伴就有機會多認識自己一些。 由楊嘉玲心理師和陳怡璇劇作家共同對談，透過心理學的角度，用有趣易懂的話語，探討各種生活議題，無論是工作、感情、家庭、婚姻、親子、理財、溝通等，帶給你不同的發現。 讓【心理敲敲門】陪著你一起看社會、想自己、過生活、聊領悟！</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop17">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>傳統教育無法滿足現代人大大小小的好奇，每一個領域都有值得學習的專業與精神，但一天就只有24小時，該怎麼辦？ 沒關係，就讓【誰來作客】滿足你。 節目將邀請各界專家或知名人士，例如全方位藝人曾寶儀、職場專家邱文仁、諮商心理師陳志恆……，透過深度訪談，異領域的探討，激盪出不同的火花與思維。 在人和人的分享中，看見創新，相信改變，為無限賽局的時代做好準備！ 想要跟上時代的浪潮，快來收聽【誰來作客】。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop18">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>喜歡心理學，卻沒空閱讀，或讀不懂專有名詞嗎？讓心理學家裘凱宇用淺醒易懂的語言，帶領你領略人性的奧妙與複雜，無論經典的實驗、發人省思的故事，你將發現心理學是一門既實用又有趣的科學，想要學會時間管理、人際溝通、生涯發展、自我探索、創意思維……，歡迎收聽【一天聽一點】，用最少的時間，感受最豐富的心靈旅程。 「自我探索」系列：認識自己是一條沒有終點的道路，每一個面向都藏著你最重要的在乎，想要被接納、被認同，你得先從喜歡自己開始。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop19">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>喜歡心理學，卻沒空閱讀，或讀不懂專有名詞嗎？讓心理學家裘凱宇用淺醒易懂的語言，帶領你領略人性的奧妙與複雜，無論經典的實驗、發人省思的故事，你將發現心理學是一門既實用又有趣的科學，想要學會時間管理、人際溝通、生涯發展、自我探索、創意思維……，歡迎收聽【一天聽一點】，用最少的時間，感受最豐富的心靈旅程。 「人際溝通」系列：想把溝通做好，不只要會說，更要會聽、會觀察，唯有你把人先放進心裡，別人才會把你看進眼裡。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="mb_pop20">
				<div className="pagesize">
					<div className="popup_box">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<h3 className="tit_main">節目簡介</h3>
							<p>慢老是一種可以學習的生活技術，擁有慢老10堂課，你可以為生命立下保護傘，活得自律、享受生命、活躍自在，變老的過程可以緩慢、細微，而且出乎意料的優雅。 黃惠如認為，老化不可逆，我們無法抗老、凍齡或逆齡，但我們能夠決定我們快老或慢老，日日實踐，活成期望中的那個自己。</p>
						</div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
						<li><a href="/container/caption/Caption0301">音樂故事清單</a></li>
						<li><a href="/container/caption/Caption0304">i聽聽精選20集</a></li>
					</ul>
					<h2 className="tit_main">i聽聽精選20集</h2>
					<div className="content_box music_box mb_book mb_ichoice">
						<div className="cb_set">
							<p className="total_info"><span>20</span>集，共<span>1</span>頁</p>
							<div className="mb_detail flex_set">
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_01.jpg").default} alt="ichoice_01" /></div>
										<div className="mb_main">
											<h4>比利大視野：<br />其實冰島的食物很迷人</h4>
											<ul className="list_sty">
												<li>主持人：Billy</li>
												<li>時長 16分鐘</li>
											</ul>
											<a id="mb_pop01" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>常聽人說冰島食物不好吃，冰島食物真的不好吃嗎？其實冰島的食物很迷人，聽聽Billy怎麼說。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_02.jpg").default} alt="ichoice_02" /></div>
										<div className="mb_main">
											<h4>鴨子一窩瘋：<br />因為見識過這世界的各種色階，才能比對出自己的生命有多麽鮮豔</h4>
											<ul className="list_sty">
												<li>主持人：高伊玲（鴨子）</li>
												<li>時長 25分鐘</li>
											</ul>
											<a id="mb_pop02" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>什麼是旅行的意義？對於多數人而言，啟程的理由可以是為了玩樂放鬆，為了和自己相處，又或者不需要理由說走就走，但是對於外景節目主持人來說是抱持著一個重大的任務</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_03.jpg").default} alt="ichoice_03" /></div>
										<div className="mb_main">
											<h4>博物館二三事：<br />介紹大英博物館</h4>
											<ul className="list_sty">
												<li>主持人：老派博粉家琳</li>
												<li>時長 3分鐘</li>
											</ul>
											<a id="mb_pop03" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>說到大英博物館，絕對不能錯過「伊麗莎白二世大中庭」，這裡承載英國的哪段歷史？而大英博物館的成立，來自誰呢？曾經風華傲視的日不落帝國，等待您一探究竟。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_04.jpg").default} alt="ichoice_04" /></div>
										<div className="mb_main">
											<h4>今天好想藥：<br />看不懂藥袋不會吃藥？藥剩下來不知道丟哪？</h4>
											<ul className="list_sty">
												<li>主持人：蘇柏名</li>
												<li>時長 14分鐘</li>
											</ul>
											<a id="mb_pop04" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>根據統計，每個老人家一天都要吃進5~6顆藥，但看完病的老人家或是外籍照護者卻常常因為看不懂藥袋的指示而被吃藥所苦。另外有的人因為不懂得閱讀藥袋，副作用發生的時候，過度恐慌，也不知道該如何求助。小小一個藥袋，學問多著呢！另外家中剩藥該怎麼處理？該丟到垃圾桶還是全部拿到藥局？別擔心，藥師教你。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_05.jpg").default} alt="ichoice_05" /></div>
										<div className="mb_main">
											<h4>池永昌醫師的乳房私房話：<br />很多女生都有的「乳房老鼠」</h4>
											<ul className="list_sty">
												<li>主持人：池永昌</li>
												<li>時長 8分鐘</li>
											</ul>
											<a id="mb_pop05" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>怎麼會有小老鼠，在乳房裡面跑來跑去？有時候不只一隻，還有好多隻！到底發生了什麼事？需要把「牠」開刀拿出來嗎？</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_06.jpg").default} alt="ichoice_06" /></div>
										<div className="mb_main">
											<h4>健康小管家：<br />如何選擇洗手產品（水、肥皂、洗手液）對抗冠狀病毒</h4>
											<ul className="list_sty">
												<li>主持人：陳于雯、唐彥儒</li>
												<li>時長 6分鐘</li>
											</ul>
											<a id="mb_pop06" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>2020年最讓人聞風桑膽的就是新型冠狀病毒了。在洗手產品的選擇上是否十分困擾您呢?一定要使用肥皂嗎?清水洗不行嗎?該優先選擇抗菌洗手乳嗎?讓生活護理師Wendy報你知！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_07.jpg").default} alt="ichoice_07" /></div>
										<div className="mb_main">
											<h4>尼奧媽的單身派對：<br />尼奧媽是噠咧？</h4>
											<ul className="list_sty">
												<li>主持人：尼奧媽</li>
												<li>時長 7分鐘</li>
											</ul>
											<a id="mb_pop07" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>簡單跟大家說說我是誰，接下來會跟你們分享的主題有哪些，試播集就不要太搞威，怕嚇到你們，所以還是收聽接下來的節目吧！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_08.jpg").default} alt="ichoice_08" /></div>
										<div className="mb_main">
											<h4>童書裡的荒漠甘泉：<br />面對壓力</h4>
											<ul className="list_sty">
												<li>主持人：張淑瓊</li>
												<li>時長 4分鐘</li>
											</ul>
											<a id="mb_pop08" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>壓力，是現代人經常面對的。壓力使人喘不過氣、壓力使人脾氣暴怒、壓力使人低落沮喪.....我們該如何面對壓力，而不被壓力擊潰呢？從頂上往下看吧！今天，我們就用《公雞的願望》來談談面對壓力吧！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_09.jpg").default} alt="ichoice_09" /></div>
										<div className="mb_main">
											<h4>快樂共讀行不行：<br />孩子！到底聽懂了沒？</h4>
											<ul className="list_sty">
												<li>主持人：譚淑娟</li>
												<li>時長 6分鐘</li>
											</ul>
											<a id="mb_pop09" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>在陪伴孩子成長的過程當中，我們擁有許多感動的時刻，我們感動於孩子開口叫「爸爸」「媽媽」的那一刻，不過你有沒有想過，在孩子學會叫「爸爸」「媽媽」之前，其實我們已經對著他反覆地說了無數次的「爸爸」「媽媽」了。同樣的道理；在親子共讀之後，當我們渴望知道孩子到底聽懂了沒？那我們應該也需要給孩子更多的時間去思考和內化。今天分享的繪本：《貪心的草莓大叔》、《大吼大叫的企鵝媽媽》</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_10.jpg").default} alt="ichoice_10" /></div>
										<div className="mb_main">
											<h4>生活侯賽雷：<br />專訪林萃芬-「疫」職難求！教你如何面對危機與轉型</h4>
											<ul className="list_sty">
												<li>主持人：侯昌明</li>
												<li>時長 27分鐘</li>
											</ul>
											<a id="mb_pop10" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>新冠肺炎疫情導致世界性的不景氣，企業以無薪假的方式來度過景氣寒冬，這個時候，員工又擔心無班可上，沒有收入該怎麼辦。此外，更有不少國際級的百年公司或機構面臨倒閉或裁員的困境，由於事發太過突然，以前每天都去的公司，現在居然大門深鎖，員工陷入極度恐慌焦慮中，無法喘息呼吸。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_11.jpg").default} alt="ichoice_11" /></div>
										<div className="mb_main">
											<h4>趙小僑很有事：<br />專訪黃經典-媽媽下班不用趕，原來做菜可以這麼輕鬆</h4>
											<ul className="list_sty">
												<li>主持人：趙小僑</li>
												<li>時長 19分鐘</li>
											</ul>
											<a id="mb_pop11" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>餐桌上最美味、最健康的食物，無論老人、大人或小孩都能吃得津津有味，尤其是職場媽媽一下班，簡單動手拌一拌，還能節省65%以上的烹調時間，即可餐餐變化出一桌豐盛美味的佳餚。今天就教大家 清爽、開胃、吃不膩，輕鬆討好家人的胃，吃得開心又滿足 的涼拌菜。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_12.jpg").default} alt="ichoice_12" /></div>
										<div className="mb_main">
											<h4>劉亮佐有藝思：<br />專訪岳清清-一堂給各行各業的編劇課</h4>
											<ul className="list_sty">
												<li>主持人：劉亮佐</li>
												<li>時長 25分鐘</li>
											</ul>
											<a id="mb_pop12" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>編劇不是只用在電視或電影，其實你也可以用編劇概念，運用在提案上，讓你掌握全場！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_13.jpg").default} alt="ichoice_13" /></div>
										<div className="mb_main">
											<h4>寶石獵人李承倫：<br />認識彩色寶石</h4>
											<ul className="list_sty">
												<li>主持人：李承倫</li>
												<li>時長 7分鐘</li>
											</ul>
											<a id="mb_pop13" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>彩色寶石的範圍非常廣泛，此集教你寶石學的基本概論，讓你逐步懂得鑑賞彩色寶石。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_14.jpg").default} alt="ichoice_14" /></div>
										<div className="mb_main">
											<h4>妮說BOOK，我說可：<br />繡上家族的味道：夏夏的《傍晚五點十五分》</h4>
											<ul className="list_sty">
												<li>主持人：蔣亞妮</li>
												<li>時長 29分鐘</li>
											</ul>
											<a id="mb_pop14" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>夏夏的散文是繡。有些人是撿、是剪、是潑灑，但她是繡。卻也不同小說家駱以軍的亂針刺繡，她是綿密的織理。針頭藏在背面暗裡，悲傷也是，淡淡繡出了一片生活的真實面貌。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_15.jpg").default} alt="ichoice_05" /></div>
										<div className="mb_main">
											<h4>有聲書評：<br />專訪作家黃大米《你若委屈自己，任誰都能刻薄你》</h4>
											<ul className="list_sty">
												<li>主持人：老派博粉家琳</li>
												<li>時長 3分鐘</li>
											</ul>
											<a id="mb_pop15" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>她的文章你可能早已讀過，甚至有轉發分享。她的文章觸動你對於自身處境的反思，思考你的職場與未來。然而，你可能比較少聽她說，她的故事。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_16.jpg").default} alt="ichoice_16" /></div>
										<div className="mb_main">
											<h4>心理敲敲門：<br />解憂時間-我的老公非常酷，該怎麼辦？</h4>
											<ul className="list_sty">
												<li>主持人：楊嘉玲、陳怡璇</li>
												<li>時長 22分鐘</li>
											</ul>
											<a id="mb_pop16" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>本集對談重點：1. 處在失溫關係中，心裡的感受？2. 老公有賺錢，也有回家，是不是該珍惜？自己會不會要太多？怎麼處理心底的失落？3. 該怎麼斷捨離？離婚會比較好嗎？</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_17.jpg").default} alt="ichoice_17" /></div>
										<div className="mb_main">
											<h4>誰來作客：<br />熱門電影「婚姻故事」教我們的法律常識～嘉玲和賴芳玉律師的對談</h4>
											<ul className="list_sty">
												<li>主持人：楊嘉玲、賴芳玉</li>
												<li>時長 54分鐘</li>
											</ul>
											<a id="mb_pop17" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>情侶不合易分手，夫妻不合難「好散」，當初結婚，是為了相「伴」一生，現在離婚，是為了相「愛」一生～</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_18.jpg").default} alt="ichoice_18" /></div>
										<div className="mb_main">
											<h4>一天聽一點：自我探索<br />內向者適合什麼運動？</h4>
											<ul className="list_sty">
												<li>主持人：裘凱宇</li>
												<li>時長 5分鐘</li>
											</ul>
											<a id="mb_pop18" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>如果我是個「內向者」，那我可以選擇什麼樣的運動，更適合我、更能夠讓我這樣的一個性格跟特質，透過運動能夠得到一個好的充電呢？</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_19.jpg").default} alt="ichoice_19" /></div>
										<div className="mb_main">
											<h4>一天聽一點：人際溝通<br />重要的觀念,簡單說《認真流暢度》</h4>
											<ul className="list_sty">
												<li>主持人：裘凱宇</li>
												<li>時長 3分鐘</li>
											</ul>
											<a id="mb_pop19" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>我們在聽別人說話，其實是受到「認知流暢度」的影響。什麼叫「認知流暢度」呢？簡單來說，就是對方給我的訊息，是不是容易懂、是不是容易接收，會決定於他給我的訊息，在我心中我覺得是否「可信」跟「可靠」。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<div className="mb_img"><img src={require("../../img/ichoice_20.jpg").default} alt="ichoice_20" /></div>
										<div className="mb_main">
											<h4>黃惠如慢老的10堂課：<br />老是什麼？</h4>
											<ul className="list_sty">
												<li>主持人：尼奧媽</li>
												<li>時長 7分鐘</li>
											</ul>
											<a id="mb_pop20" className="btn_popup">節目簡介</a>
										</div>
									</div>
									<div className="mb_txt">
										<p>老是什麼？慢老是一種可以學習的生活技術，擁有慢老10堂課，你可以為生命立下保護傘，活得自律、享受生命、活躍自在，變老的過程可以緩慢、細微，而且出乎意料的優雅。 黃惠如認為，老化不可逆，我們無法抗老、凍齡或逆齡，但我們能夠決定我們快老或慢老，日日實踐，活成期望中的那個自己。</p>
									</div>
								</div>
							</div>
							{/* <ul className="page_control">
						<li><a href="music_01_06_page01.html" className="btn_prev_01"></a></li>
						<li><a href="music_01_06_page01.html" className="btn_prev_02"></a></li>
						<li className="active"><a href="javascript:void();">1</a></li>
						<li><a href="music_01_06_page02.html">2</a></li>
						<li><a href="music_01_06_page02.html" className="btn_next_01"></a></li>
						<li><a href="music_01_06_page02.html" className="btn_next_02"></a></li>
					</ul> */}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption0304;